import { createTheme } from '@mui/material/styles';
import { MixinsOptions } from '@mui/material/styles/createMixins';
import {
  buttonTheme,
  textFieldTheme,
  formControlTheme,
  autocompleteTheme,
  paperTheme,
  cardTheme,
  dialogTheme,
  accordionSummaryTheme,
  createTableCellTheme,
  createDataGridTheme,
} from './components';
import { createPalette } from './palette';
import { customShadows, shape, spacing } from './tokens';
import { typography } from './typography';
import { ThemeBranding } from './types';

export const createAppTheme = (settings: ThemeBranding) => createTheme({
  components: {
    MuiButton: buttonTheme,
    MuiTextField: textFieldTheme,
    MuiFormControl: formControlTheme,
    MuiAutocomplete: autocompleteTheme,
    MuiPaper: paperTheme,
    MuiCard: cardTheme,
    MuiDialog: dialogTheme,
    MuiAccordionSummary: accordionSummaryTheme,
    MuiTableCell: createTableCellTheme(settings),
    MuiDataGrid: createDataGridTheme(settings),
  },
  palette: createPalette(settings),
  typography, shape, spacing, customShadows,
  mixins: { MuiDataGrid: { containerBackground: settings.primaryTableHeaderColor } } as unknown as MixinsOptions,
});
